'use strict';
import { debounce } from '../utils';

function directive($document, $rootScope, lazyLoader) {
    return {
        scope: {
            fireEvent: '@',
            bounding: '=' // array of strings or single property objects for the bounding and offsets to use
        },
        transclude: true,
        template: function (element, attributes) {
            if (attributes.inline === 'true') {
                return '<span ng-if="loadNow">' + attributes.elementCode + '</span>';
            } else {
                return '<div ng-if="loadNow"><div ng-transclude></div></div>';
            }
        },
        link: function (scope, element, attrs) {
            let scrollHandler;

            scope.loadNow = false;

            scope.unbindScrollHandler = ()=> {
                $document.unbind('scroll', scrollHandler);
            };

            scope.scrollHandler = ()=> {
                let rect = element[0].getBoundingClientRect(),
                    boundingCase = lazyLoader.getBoundingCase(rect, scope.bounding);

                if (boundingCase) {
                    // Variable that triggers the transclude
                    scope.loadNow = true;

                    $rootScope.$broadcast(scope.fireEvent);

                    scope.unbindScrollHandler();
                    scope.$digest();
                } else {
                    scope.loadNow = false;
                }
            };

            scrollHandler = debounce(scope.scrollHandler, 50);

            if (attrs.bypassLazyload) {
                scope.loadNow = true;
            } else {
                $document.on('scroll', scrollHandler);
                $document.ready(scope.scrollHandler);
            }

        }
    };
}

directive.$inject = ['$document', '$rootScope', 'lazyLoader'];

export default directive;
